import { ActionTypes as LocationActionTypes } from '../../Shared/Locations/actions';
import { ActionTypes } from '../actions/constants';

const initialState = {
    bookingSpotlightIsOn: false,
    carrierId: '-1',
    deletePreviewProviderFailed: false,
    deletePreviewProviderSucceeded: false,
    deletingPreviewProvider: false,
    expandedLocations: {},
    initParameters: {},
    mapIsActive: false,
    planId: '-1',
    user: {},
};

export default function pageReducer(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.INITIALIZE:
        case ActionTypes.CHANGE_INSURANCE:
        case ActionTypes.CHANGE_PROCEDURE:
            return {
                ...state,
                ...action.payload,
            };

        case ActionTypes.SHOW_MAP:
            return {
                ...state,
                mapIsActive: true,
            };

        case ActionTypes.HIDE_MAP:
            return {
                ...state,
                mapIsActive: false,
            };

        case ActionTypes.TURN_BOOKING_SPOTLIGHT_ON:
            return {
                ...state,
                bookingSpotlightIsOn: true,
            };

        case ActionTypes.TURN_BOOKING_SPOTLIGHT_OFF:
            return {
                ...state,
                bookingSpotlightIsOn: false,
            };

        case ActionTypes.UPDATE_USER:
            return {
                ...state,
                user: action.payload,
            };

        case ActionTypes.DELETING_PREVIEW_PROVIDER:
            return {
                ...state,
                deletingPreviewProvider: true,
            };

        case ActionTypes.DELETE_PREVIEW_PROVIDER_SUCCESS:
            return {
                ...state,
                deletingPreviewProvider: false,
                deletePreviewProviderSucceeded: true,
            };


        case ActionTypes.DELETE_PREVIEW_PROVIDER_FAILURE:
            return {
                ...state,
                deletingPreviewProvider: false,
                deletePreviewProviderFailed: true,
            };

        case LocationActionTypes.TOGGLE_LOCATION_EXPANDED:
            return {
                ...state,
                expandedLocations: {
                    ...state.expandedLocations,
                    [action.locationId]: !state.expandedLocations[action.locationId],
                },
            };

        default:
            return state;
    }
}
